module.exports = __webpack_public_path__ + "static/local-gov-61c5ee155efca54e8b4edb78ad30b844.mp4";